import { FetchData } from "services/api";
import { buildCityByPostalBody } from "utils/geo/citySearch";

export const fetchCityByPostal = (countryName, postalcode, signal) =>
  FetchData("/api/external/city", {
    method: "POST",
    body: JSON.stringify(buildCityByPostalBody(countryName, postalcode)),
    signal,
  });
